import { get } from 'lodash';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { UserService } from '../../providers/user/user.service';

@Component({
  selector: '[toast-component]',
  templateUrl: './toast.html',
  styleUrls: ['./notifications.style.scss'],
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          display: 'none',
          opacity: 0
        })
      ),
      state('active', style({})),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ],
  preserveWhitespaces: false
})
export class ToastComponent extends Toast implements OnInit {
  @HostBinding(`class.dark-theme`) isDarkTheme;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  get scope(): any {
    return get(this.options, 'scope', {});
  }

  constructor(
    private readonly userService: UserService,
    toastrService: ToastrService,
    toastPackage: ToastPackage
  ) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {
    if(this.userService.getThemeFromStorage() === 'dark') {
      this.isDarkTheme = true;
    }
  }
}
